import { render } from "./Contact.vue?vue&type=template&id=27373b22&scoped=true"
const script = {}

import "./Contact.vue?vue&type=style&index=0&id=27373b22&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27373b22"]])

export default __exports__